import { Button, DropdownMenu, Icon } from '@kontentino/ui';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faShare } from '@fortawesome/pro-regular-svg-icons/faShare';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUserCheck } from '@fortawesome/pro-regular-svg-icons/faUserCheck';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { FC } from 'react';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import { useTranslation } from 'react-i18next';
type Props = {
  onClientApprovalClick: () => void;
  onInternalApprovalClick: () => void;
  onSharePublicLinkClick: () => void;
};

const PostModalFooterSendForApprovalDropdown: FC<Props> = ({
  onClientApprovalClick,
  onInternalApprovalClick,
  onSharePublicLinkClick,
}) => {
  const { t } = useTranslation();
  return (
    <UserPermissionGate
      scopes={[
        UserPermission.POST_SEND_FOR_CLIENT_APPROVAL,
        UserPermission.POST_INTERNAL_APPROVE,
      ]}
    >
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button
            variant="primary"
            data-name="posts-preview_send-for-approval"
            data-cy="post-send-for-approval-dropdown-button"
          >
            <Icon icon={faUserCheck} />
            {t('sendForApproval')}
            <Icon icon={faChevronDown} />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content data-name="posts-preview_send-for-approval_menu">
          <UserPermissionGate
            scopes={UserPermission.POST_SEND_FOR_CLIENT_APPROVAL}
          >
            <DropdownMenu.Item
              data-name="posts-preview-send-for-approval-client"
              data-cy="post-send-for-client-approval-dropdown-option"
              onSelect={() => onClientApprovalClick()}
            >
              <Icon icon={faUser} />
              {t('clientApproval')}
            </DropdownMenu.Item>
          </UserPermissionGate>
          <UserPermissionGate
            scopes={UserPermission.POST_SEND_FOR_INTERNAL_APPROVAL}
          >
            <DropdownMenu.Item
              data-name="posts-preview-send-for-approval-internal"
              data-cy="post-send-for-internal-approval-dropdown-option"
              onSelect={() => onInternalApprovalClick()}
            >
              <Icon icon={faUsers} />
              {t('internalApproval')}
            </DropdownMenu.Item>
          </UserPermissionGate>
          <DropdownMenu.Item
            data-name="posts-send-for-approval-share-public-link"
            data-cy="post-share-public-link-dropdown-option"
            onSelect={() => onSharePublicLinkClick()}
          >
            <Icon icon={faShare} />
            {t('sharePublicLink')}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </UserPermissionGate>
  );
};

export default PostModalFooterSendForApprovalDropdown;
